import { get } from 'lodash'
import { useQuery } from 'react-query'
import hooks from '../../../../hooks'

const useCourseEnrollability = ({
    courseId
}) => {

    const { api, endpoints, url } = hooks.useApi()
    const { id: userId } = hooks.useCurrentUser()
    const cacheKeys = hooks.useCacheKeys()

    const { data, isLoading } = useQuery(
        [cacheKeys.COURSES, courseId, 'enrollability'],
        () => api.get(url(endpoints.userCourseEnrollability, { courseId, userId })),
        {
            enabled: userId && courseId
        }
    )

    return {
        isLoadingEnrollability: isLoading,
        enrollable: get(data, 'enrollable', false),
        reason: get(data, 'reason'),
        conflicts: get(data, 'conflicts', [])
    }
}

export default useCourseEnrollability
